import React from "react";
import { connect } from 'react-redux';
import TosNavBar from "components/Navbars/TosNavBar.jsx";
import { setBeacon } from '../../redux/actions/rLink.action';
import { getInit } from '../../redux/actions/init.action';
import Footer from "components/Footer/Footer.jsx";

class Tos extends React.Component {
    constructor(props) {
      super(props);
    }
    componentDidMount = async () => {
      await this.props.getInit();
      setTimeout(() => {
        const beacon = document.getElementById(typeof(chrome) == "object" ? "chromeAddon" : "mozAddon");
        const isPresent = beacon && beacon.innerHTML === "1.0.1";
        this.props.setBeacon(isPresent);
      }, 250);
    }
    render() {
        return (
            <>
                <TosNavBar/>
                <div className="content">
                    <div className="privacy">
                        <div className="privacy-head">
                        <h3>Terms of Services</h3>
                        </div>
                        <div className="privacy-block">
                            <h4 className="text-center">As a condition to your use of the Service, you agree not to :</h4>
                            <div className="privacy-block-body">
                                <ul>
                                    <li>
                                    impersonate or misrepresent your affiliation with any person
                                    or entity; access, tamper with, or use any non-public areas
                                    of the Service or {`rustlink.io's`} computer systems;
                                    </li>
                                    <li>
                                    attempt to probe, scan, or test the vulnerability of the
                                    Service or any related system or network or breach any
                                    security or authentication measures used in connection with
                                    the Service and such systems and networks;
                                    </li>
                                    <li>
                                    attempt to decipher, decompile, disassemble, reverse
                                    engineer or otherwise investigate any of the software or
                                    components used to provide the Service;
                                    </li>
                                    <li>
                                    harm or threaten to harm other users in any way or interfere
                                    with, or attempt to interfere with, the access of any user,
                                    host or network, including without limitation, by sending a
                                    virus, overloading, flooding, spamming, or mail-bombing the
                                    Service;
                                    </li>
                                    <li>
                                    {' '}
                                    provide payment information belonging to a third party;
                                    </li>
                                    <li>
                                    use the Service in an abusive way contrary to its intended
                                    use, to rustlink.io policies and instructions and to any
                                    applicable law;
                                    </li>
                                    <li>
                                    systematically retrieve data or other content from the
                                    Service to create or compile, directly or indirectly, in
                                    single or multiple downloads, a collection, compilation,
                                    database, directory or the like, whether by manual methods,
                                    through the use of bots, crawlers, or spiders, or otherwise;
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="privacy-block">
                            <h4 className="text-center">Requirements to use the service</h4>
                            <div className="privacy-block-body">
                                <p>We offer a service for individuals able to agree on a contract with us. The user must abide by the rules of this website.</p>
                            </div>
                        </div>
                        <div className="privacy-block">
                            <h4 className="text-center">Services</h4>
                            <div className="privacy-block-body">
                                <p>
                                We agree to offer several services to the user. We keep the right to change or shut down our services at any time without any explanations. A purchase on rustLink grants you access to a private part of the website, by consequence, changes or deletions on these pages can occure at any time without advance notice.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-block">
                        <h4 className="text-center">Personal information</h4>
                        <div className="privacy-block-body">
                            <p>
                            The user certifies that the information provided are complete, up-to-date, true and accurate. The user commits to edit his information if they change in the future.
                            </p>
                        </div>
                        </div>
                        <div className="privacy-block">
                        <h4 className="text-center">User account</h4>
                        <div className="privacy-block-body">
                            <p>The user account is subject to a personal use only. Only the physical owner of the account is authorized to log to the user account.</p>
                        </div>
                        </div>
                        <div className="privacy-block">
                        <h4 className="text-center">Infringements</h4>
                        <div className="privacy-block-body">
                            <p>The user acknowledges not to attempt to disturb our services by any mean, such as server attacks. The user must not attempt to bypass the limitations or use a breach in our payment system. Reproduction, partial or full, of the content of this website is forbidden without the agreement of its owner.</p>
                        </div>
                        </div>
                        <div className="privacy-block">
                        <h4 className="text-center">Indemnity and no refund policy</h4>
                        <div className="privacy-block-body">
                            <p>If the service becomes unreachable for a long time, we reserve the right to compensate for the downtime. Instead payments are non refundable.</p>
                        </div>
                        </div>
                        <div className="privacy-block">
                        <h4 className="text-center">Quality of Service</h4>
                        <div className="privacy-block-body">
                            <p>The service we offer is not subject to any guarantee. Our offer is based on the 'best effort', that is to say that we strive to offer a functional service.</p>
                        </div>
                        </div>
                        <div className="privacy-block">
                        <h4 className="text-center">Access to the service</h4>
                        <div className="privacy-block-body">
                            <p>We reserve the right to refuse access to our service if an abuse disrupting the stability of our service is found.</p>
                        </div>
                        </div>
                        <div className="privacy-block">
                        <h4 className="text-center">Affiliation</h4>
                        <div className="privacy-block-body">
                            <p>We are in NO WAY affiliated with or endorsed by the Valve
                                corporation, Discord, or Facepunch Studios.</p>
                        </div>
                        </div>
                        <div className="privacy-block">
                            <h4 className="text-center">Affiliation</h4>
                            <div className="privacy-block-body">
                                <p>
                                    We may terminate or suspend access to our Service immediately,
                                    without prior notice or liability, for any reason whatsoever,
                                    including without limitation if you breach the Terms. All
                                    provisions of the Terms which by their nature should survive
                                    termination shall survive termination, including, without
                                    limitation, ownership provisions, warranty disclaimers,
                                    indemnity and limitations of liability.
                                </p>
                                <p>
                                    Upon termination, your right to use the Service will
                                    immediately cease. If you wish to terminate your account, you
                                    may simply discontinue using the Service.
                                </p>
                                <p>
                                    All provisions of the Terms which by their nature should
                                    survive termination shall survive termination, including,
                                    without limitation, ownership provisions, warranty
                                    disclaimers, indemnity and limitations of liability.
                                </p>
                            </div>
                        </div>
                        <div className="privacy-block">
                            <h4 className="text-center">Links To Other websites</h4>
                            <div className="privacy-block-body">
                                <p>
                                    Our Service may contain links to third-party websites or
                                    services that are not owned or controlled by rustlink.io.
                                </p>
                                <p>
                                    rustlink.io has no control over and assumes no
                                    responsibility for the content, privacy policies, or practices
                                    of any third party websites or services. You further
                                    acknowledge and agree that rustlink.io will not be
                                    responsible or liable, directly or indirectly, for any damage
                                    or loss caused or alleged to be caused by or in connection
                                    with use of or reliance on any such content, goods or services
                                    available on or through any such websites or services.
                                </p>
                                <p>
                                    We strongly advise you to read the terms and conditions and
                                    privacy policies of any third-party websites or services that
                                    you visit.
                                </p>
                            </div>
                        </div>
                        {/*<div className="privacy-block">
                            <h4 className="text-center">Administrator</h4>
                            <div className="privacy-block-body">
                                <ul>
                                    <li>Gold Rush</li>
                                    <li>Country - France</li>
                                    <li>Company SIREN - ro 820 779 585 R.C.S.</li>
                                    <li>{`Registration address - 6 rue d'Armaillé Paris FRANCE`}</li>
                                    <li>ZIP / Postal Code - 75017</li>
                                    <li>Email: support@rustlink.io</li>
                                    <li>Phone: +33780980174</li>
                                </ul>
                            </div>
                        </div>*/}
                    </div>
                </div>
                <Footer fluid />
            </>
        )};
};

const mapDispatchToProps = {
    setBeacon,
    getInit
};

export default connect(null, mapDispatchToProps)(Tos);